<template>


  <div id="app">
    <router-view/>
  </div>

</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html,
body {
  margin: 0;
  height: 100%;
  width: 100%;
}
p,
ul {
  padding: 0;
  margin: 0;
}
ul li {
  list-style-type: none;
}
html {
  overflow: auto;
  font-size: 80px;
  @media (min-width: 1440px) {
    font-size: 90px;
  }
  @media (min-width: 1600px) {
    font-size: 100px;
  }
  @media (min-width: 1921px) {
    font-size: 110px;
  }
  @media (min-width: 2560px) {
    font-size: 120px;
  }
}
body {
  overflow: hidden;
  height: 100%;
  width: 100%;
  min-width: 1440px;
  min-height: 710px;
  position: relative;
  font-size: 16px;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue